import React from 'react'
import { navigate } from 'gatsby'

import { isBrowser } from './src/services/auth'
import { Auth0Context, Auth0Provider } from '@auth0/auth0-react'


export const wrapRootElement = ({ element }) => {
  const onRedirectCallback = (appState) => {
    navigate(appState && appState.targetUrl ? appState.targetUrl : isBrowser() ? window.location.pathname : '/')
  }
  const audience = process.env.GATSBY_AUTH0_AUDIENCE || 'https://krane-dev.orikami.tech'

  return (
    <Auth0Provider
      domain={process.env.GATSBY_AUTH0_DOMAIN}
      clientId={process.env.GATSBY_AUTH0_CLIENTID}      
      authorizationParams={{
        redirect_uri: process.env.GATSBY_AUTH0_CALLBACK || ``,
        audience,
      }}
      cacheLocation="localstorage"
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
    >
      {element}
    </Auth0Provider>
  )
}
